(() => {
  if (customElements.get('products-row')) {
    return;
  }

  // Matches the theme's tablet/desktop breakpoint.
  const DESKTOP_BP = 750;

  class ProductsRow extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.resizeTimer = null;

      this.swiperEl = this.querySelector('[data-slider]');
      this.sliderPrev = this.querySelector('.swiper-arrow--prev');
      this.sliderNext = this.querySelector('.swiper-arrow--next');

      this.desktopSlider = this.dataset.desktopSlider === 'true';
      this.mobileSlider = this.dataset.mobileSlider === 'true';
      this.columnsDesktop = Number(this.dataset.columnsDesktop) || 4;
      this.columnsMobile = Number(this.dataset.columnsMobile) || 2;

      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (!this.swiperEl) return;

      this.lastDesktop = this.isDesktop;
      this.evaluate();

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroySlider();
    }

    get isDesktop() {
      return window.innerWidth >= DESKTOP_BP;
    }

    shouldSlide() {
      return this.isDesktop ? this.desktopSlider : this.mobileSlider;
    }

    // Init the slider for the current breakpoint, or fall back to a CSS grid.
    evaluate() {
      if (this.shouldSlide()) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (typeof Swiper === 'undefined') return;

      const desktop = this.isDesktop;
      const columns = desktop ? this.columnsDesktop : this.columnsMobile;
      // Peek the next card on mobile so it reads as a swipeable row.
      const peek = desktop ? 0 : 0.2;

      // Re-create so slides-per-view always matches the active breakpoint.
      this.destroySlider();

      this.slider = new Swiper(this.swiperEl, {
        slidesPerView: columns + peek,
        spaceBetween: desktop ? 20 : 10,
        watchOverflow: true,
        navigation: {
          prevEl: this.sliderPrev,
          nextEl: this.sliderNext,
        },
      });
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        const desktop = this.isDesktop;
        if (desktop === this.lastDesktop) return;
        this.lastDesktop = desktop;
        this.evaluate();
      }, 150);
    }

    // Called by hero-slider when a hidden panel becomes visible: Swiper
    // mis-measures while display:none, so re-sync once it's on screen.
    refresh() {
      if (this.slider) {
        this.slider.update();
      } else {
        this.evaluate();
      }
    }
  }

  customElements.define('products-row', ProductsRow);
})();
